import {Component, Input} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Component({
  selector: 'masquerade-banner',
  templateUrl: './masquerade-banner.component.html',
  styleUrls: ['./masquerade-banner.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class MasqueradeBannerComponent {

  @Input() username = '';

  showDetails$ = new BehaviorSubject(false);

  actions = [
    'masquerade.updating-status',
    'masquerade.favoriting',
    'masquerade.completing-review',
    'masquerade.signing-timecards',
    'masquerade.update-settings'
  ];

  constructor() {
  }

}
